import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import ".././../styles/diet/diet.css";
import DietCards from "../../components/diet/diet-dashboard/DietCards";
import DdFilters from "../../components/diet/diet-dashboard/DdFilters";
import { selectToken } from "../../components/auth/auth.selector";
import {
  fetchDietCardsData,
  fetchDietStatsData,
} from "../../redux/reducers/apiSlice";
import ReactVortoxSpinner from "../../components/common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../components/payment-link-system/PaymentLinkTable";
import { formatDateTimezon } from "../../components/common-data/Converts";
import { BodyBuilder } from "../../exports/Images";
import DietPlansTab from "../../components/diet/diet-dashboard/DietPlansTab";
import HeadingFilterAdd from "../../components/diet/common/HeadingFilterAdd";
import HelmetWrapper from "../../HelmetWrapper";
import { CheckCircleIcon, CrossCircleIcon } from "../../images/icons/icons";

const DietDashboard = () => {
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const { dietPlanLoading, dietStatsData, dietCardsData } = useSelector(
    (state) => state.api
  );

  const iniDdFilters = {
    status: "",
    searchString: "",
  };
  const [ddFilters, setDdFilters] = useState(iniDdFilters);
  const iniDpFilters = {
    status: "",
    searchString: "",
    isSearch: false,
  };
  const [dpFilters, setDpFilters] = useState(iniDpFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const [sendableQPs, setSendableQPs] = useState("");
  const [sendableDPQPs, setSendableDPQPs] = useState("");

  const iniDietStats = {};
  const [dietStats, setDietSats] = useState(iniDietStats);

  const iniCardValues = {
    filterType: "total_members",
    cardData: [],
    isPage: 0,
    pagination: [],
  };
  const [cardValues, setCardValues] = useState(iniCardValues);
  const { filterType, cardData, isPage, pagination } = cardValues || {};

  const onClickSearch = (name) => {
    if (name === "dp") {
      const searchQP = dpFilters.searchString
        ? `&search=${dpFilters.searchString}`
        : "";
      setDpFilters((prevs) => ({ ...prevs, isSearch: true }));
      setSendableDPQPs((prevQP) => {
        const updatedQP = prevQP + searchQP;
        return updatedQP;
      });
      resetPagination();
    } else {
      setSearchFilterApplied(true);
      const searchQP = ddFilters.searchString
        ? `&search=${ddFilters.searchString}`
        : "";

      setSendableQPs((prevQP) => prevQP + searchQP);
    }
  };

  // const handleKeyPress = (e, name) => {
  //   if (name === "dp" && e.key === "Enter") {
  //     onClickSearch(name);
  //   } else if (e.key === "Enter") {
  //     onClickSearch();
  //   }
  // };

  const resetPagination = () => {
    setCardValues((prevs) => ({ ...prevs, isPage: 0 }));
  };

  function getDietStats(sendableQPs) {
    dispatch(
      fetchDietStatsData({
        queryParameters: sendableQPs,
        token: token,
      })
    );
  }

  function getDietCardDetails(filterType, sendableQPs, isPage) {
    dispatch(
      fetchDietCardsData({
        pageNo: isPage + 1,
        limit: 10,
        queryParameters: `&type=${filterType}` + sendableQPs,
        token: token,
      })
    );
  }

  useEffect(() => {
    const statusQP = ddFilters.isActive?.value
      ? `&status=${ddFilters.isActive.value}`
      : "";
    const queryParameters = `${statusQP}`;
    setSendableQPs(queryParameters);
    resetPagination();
  }, [ddFilters]);

  // useEffect(() => {
  //   const statusQP = dpFilters.isActive?.value
  //     ? `&status=${dpFilters.isActive.value}`
  //     : "";
  //   const queryParameters = `${statusQP}`;
  //   setSendableDPQPs(queryParameters);
  //   resetPagination();
  // }, [dpFilters]);

  useEffect(() => {
    getDietStats(sendableQPs);
  }, [sendableQPs]);

  useEffect(() => {
    if (dietStatsData?.status && dietStatsData?.data) {
      setDietSats(dietStatsData.data);
    } else {
      setDietSats(iniDietStats);
    }
  }, [dietStatsData]);

  useEffect(() => {
    if (filterType) {
      getDietCardDetails(filterType, sendableQPs, isPage);
    }
  }, [filterType, sendableQPs, isPage]);

  useEffect(() => {
    if (ddFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setSendableQPs((prevQP) => prevQP.replace(/&search=[^&]*/, ""));
    }
  }, [ddFilters.searchString]);

  useEffect(() => {
    if (dpFilters.searchString?.length === 0) {
      setDpFilters((prevs) => ({ ...prevs, isSearch: false }));
      setSendableDPQPs((prevQP) => prevQP.replace(/&search=[^&]*/, ""));
      resetPagination();
    }
  }, [dpFilters.searchString]);

  useEffect(() => {
    if (dietCardsData?.status && dietCardsData?.data) {
      const { data, pagination } = dietCardsData || {};

      setCardValues((prevs) => ({
        ...prevs,
        cardData: data,
        pagination: pagination,
      }));
    } else {
      setCardValues((prevs) => ({ ...prevs, cardData: [], pagination: [] }));
    }
  }, [dietCardsData]);

  const tbColumns = [
    {
      dataField: "user_profile",
      text: "User Profile",
      formatter: (cell, row) => {
        return (
          <div className="tb-img lightBorderRadiusImg">
            <img
              src={row?.user_profile || BodyBuilder}
              alt={row?.user_name || "NA"}
              className="image"
              style={{
                height: "100px",
                width: "100px",
                objectFit: "contain",
              }}
            />
          </div>
        );
      },
    },
    {
      dataField: "user_name",
      text: "member info / Fitness Profile",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.user_name || "NA"}
            {row?.is_completed === 1 ? (
              <CheckCircleIcon />
            ) : (
              <CrossCircleIcon />
            )}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.user_mobile || ""}
              <br />
              {row?.user_email || ""}
            </small>
          </span>
        );
      },
    },
    // {
    //   dataField: "user_mobile",
    //   text: "user mobile",
    //   formatter: (cell, row) => {
    //     return <span className="tb-data">{row?.user_mobile || "NA"}</span>;
    //   },
    // },
    // {
    //   dataField: "user_email",
    //   text: "user email",
    //   formatter: (cell, row) => {
    //     return (
    //       <span className="tb-data" style={{ textTransform: "lowercase" }}>
    //         {row?.user_email || "NA"}
    //       </span>
    //     );
    //   },
    // },
    // {
    //   dataField: "dietician_name",
    //   text: "dietician name",
    //   formatter: (cell, row) => {
    //     return <span className="tb-data">{row?.dietician_name || "NA"}</span>;
    //   },
    // },
    {
      dataField: "gym_name",
      text: "gym",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "assigned_dietpackage_name",
      text: "dietpackage",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.assigned_dietpackage_name || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "user_dietpreference",
      text: "dietpreference",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">{row?.user_dietpreference || "NA"}</span>
        );
      },
    },
    {
      dataField: "current_plan_name",
      text: "plan name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.current_plan_name || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "date added",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth90">
            {row?.date_added ? formatDateTimezon(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "current_plan_status",
      text: "current plan status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius27 bold minWidth150"
            style={{
              background:
                row?.current_plan_status === "active" ? "#E2EFD5" : "#F3DADA",
              color:
                row?.current_plan_status === "active" ? "#379C00" : "#D90000",
            }}
          >
            {row?.current_plan_status || "NA"}
          </span>
        );
      },
    },
  ];

  return (
    <HelmetWrapper title="WTF: Diet Dashboard Management">
      <Container className="bg-cloud-k px-50px dietMealsParentContainer" fluid>
        {/* <Row>
        <Col>
          <AddDiet />
        </Col>
      </Row> */}
        <Row>
          <Col>
            <DietCards dietStats={dietStats} setCardValues={setCardValues} />
          </Col>
        </Row>
        <Row>
          <Col>
            <DdFilters
              filterType={filterType}
              ddFilters={ddFilters}
              setDdFilters={setDdFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
              // handleKeyPress={handleKeyPress}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="fullWidthFlexCenter overflowAuto separatedTable">
              {dietPlanLoading ? (
                <ReactVortoxSpinner />
              ) : (
                <PaymentLinkTable
                  tableData={cardData}
                  tableColumns={tbColumns}
                  tablePagination={pagination}
                  isPage={isPage}
                  setIsPage={(value) =>
                    setCardValues((prevData) => ({
                      ...prevData,
                      isPage: value,
                    }))
                  }
                />
              )}
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <HeadingFilterAdd
              filterType={"all_diet_packages"}
              ddFilters={dpFilters}
              setDdFilters={setDpFilters}
              onClickSearch={() => onClickSearch("dp")}
              searchFilterApplied={dpFilters.isSearch}
              // handleKeyPress={(e) => handleKeyPress(e, "dp")}
              callFunction={() => {
                getDietStats(sendableQPs);
                getDietCardDetails(filterType, sendableQPs, isPage);
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <DietPlansTab
              sendableDPQPs={sendableDPQPs}
              callFunction={() => {
                getDietStats(sendableQPs);
                getDietCardDetails(filterType, sendableQPs, isPage);
              }}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default DietDashboard;
